import { useEffect } from "react";
import { useNavigation } from "@remix-run/react";
import { useAppBridge } from "@shopify/app-bridge-react";

const RouteChangeListener = () => {
  const navigation = useNavigation();
  const shopify = useAppBridge();

  useEffect(() => {
    if (!shopify || !shopify.loading) return;

    if (navigation.state === "loading") {
      shopify.loading(true);
    } else {
      shopify.loading(false);
    }
  }, [navigation.state, shopify]);

  return null;
};

export default RouteChangeListener;
